import { Check } from "lucide-react";
import { DIFFERENTIALS, waLink } from "../../data/site";
import { Reveal } from "./Reveal";
import { WhatsAppIcon } from "./WhatsAppIcon";

export const Manifesto = () => (
  <section id="diferenciais" data-testid="manifesto-section" className="bg-cream py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal className="mx-auto max-w-2xl text-center">
        <p className="font-mono text-xs font-semibold uppercase tracking-[0.24em] text-champagne-dark">
          Por que um consultor?
        </p>
        <h2 className="mt-4 font-display text-3xl font-semibold tracking-tight text-ink sm:text-4xl lg:text-5xl">
          Mais do que uma cotação.{" "}
          <em className="italic text-champagne-dark">Uma análise feita para você.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-xl border-l-2 border-champagne pl-5 text-left font-display text-lg font-medium leading-relaxed text-ink/70">
          “Meu trabalho é entender o seu momento e apresentar as opções que
          realmente fazem sentido para você.”
        </p>
      </Reveal>

      <div className="mx-auto mt-14 grid max-w-5xl grid-cols-1 gap-4 sm:grid-cols-2">
        {DIFFERENTIALS.map((d, i) => (
          <Reveal key={d.n} delay={i * 0.06}>
            <div
              data-testid={`differential-${d.n}`}
              className="group flex items-start gap-5 rounded-3xl border border-white/5 bg-surface p-7 transition-[border-color,box-shadow,transform] duration-500 hover:-translate-y-1 hover:border-champagne/30 hover:shadow-[0_20px_50px_-24px_rgba(0,0,0,0.6)]"
            >
              <span className="font-display text-lg font-semibold text-champagne/60 transition-colors duration-500 group-hover:text-champagne-dark">
                {d.n}
              </span>
              <div className="flex-1">
                <h3 className="flex items-center gap-2 font-display text-lg font-semibold tracking-tight text-ink">
                  {d.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-stone-400">{d.text}</p>
              </div>
              <Check className="mt-1 h-4 w-4 shrink-0 text-champagne" strokeWidth={3} />
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal className="mt-12 text-center">
        <a
          href={waLink("Olá! Quero uma análise personalizada de planos de saúde.")}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="manifesto-cta"
          className="group inline-flex items-center gap-3 rounded-full bg-wa px-8 py-4 text-sm font-bold text-white shadow-[0_12px_40px_-10px_rgba(37,211,102,0.45)] transition-[background-color,transform] duration-300 hover:-translate-y-1 hover:bg-wa-dark"
        >
          <WhatsAppIcon className="h-5 w-5 transition-transform duration-300 group-hover:rotate-6" />
          Quero uma análise personalizada
        </a>
      </Reveal>
    </div>
  </section>
);
